"use client";

import { fetchGetCompanyGeneralData } from "@/services/api";
import { useEffect, useState } from "react";

function goToTop() {
    $("#back-to-top").hide();

    $(window).scroll(function () {
        if ($(window).scrollTop() > 100)
            $("#back-to-top").fadeIn();
        else
            $("#back-to-top").fadeOut();
    });

    $("#back-to-top").on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 1000);
        return false;
    });
}

export default function BottomBar() {
    const [company, setCompany] = useState(null);

    useEffect(() => {
        async function loadCompany() {
            const res = await fetchGetCompanyGeneralData();
            const data = JSON.parse(res);
            setCompany(data.company);
        }

        loadCompany();
        goToTop();
    }, []);

    useEffect(() => {
        console.log(company);
    }, [company]);

    if (!company) return null;

    return (
        <div id="bottom-bar-info" className="show-footer">
            <a className="col1" href="/">
                <i className="mdi mdi-home"></i>
            </a>

            <a
                className="col2"
                href={`https://api.whatsapp.com/send?phone=${company.whatsapp}&text=Olá, gostaria de informações sobre o SELECT MULTIMARCAS`}
                target="_blank"
            >
                <i className="mdi mdi-whatsapp"></i>
            </a>

            <a className="col4" href={`tel:+55${company.phone}`}>
                <i className="mdi mdi-phone-in-talk"></i>
            </a>

            <div id="back-to-top">
                <a className="top arrow" href="#top">
                    <i className="mdi mdi-arrow-up"></i>
                </a>
            </div>
        </div>
    );
}